/**
 * Centralized translations for Login Screen
 * Contains all labels used in the login component
 */

export const LoginScreenLabels = {
    it: {
        // Form labels
        username: 'Username',
        password: 'Password',
        usernamePlaceholder: 'Inserisci il tuo username',
        passwordPlaceholder: 'Inserisci la tua password',
        loginButton: 'Accedi',
        orContinueWith: 'Oppure continua con',
        logInTitle: 'Accedi',
        loginDescription: 'Accedi al tuo account per iniziare a usare AI Plan',
        aiPlanTitle: 'AI PLAN',
        aiPlanDescription: 'AI Plan è un tool utente-friendly, basato sull\'Intelligenza Artificiale, per un processo di controllo interno più efficiente e più semplice.',
        copyright: 'by',
        
        // Error messages
        error: 'Errore!!',
        somethingWentWrong: 'Qualcosa è andato storto!!',
        yourEmailIsNotAllowedToEnterWithGoogle: 'Il tuo indirizzo email non è autorizzato a entrare con Google',
        oops: 'OOOPSS!!',
        thereWasSomeProblemsDuringTheGoogleLogin: 'Ci sono stati problemi durante l\'accesso con Google',
        UserNotFound: "Utente multiplo o non trovato",
        UserAccountDisabled: "Utente disabillitato",
        WrongOAuth: "Il tipo di autenticazione con cui stai provando ad accedere non è corretto",
        WrongPassword: "Email e/o password non corretta"
    },
    
    en: {
        // Form labels
        username: 'Username',
        password: 'Password',
        usernamePlaceholder: 'Enter your username',
        passwordPlaceholder: 'Enter your password',
        loginButton: 'Sign In',
        orContinueWith: 'Or continue with',
        logInTitle: 'Sign In',
        loginDescription: 'Sign in to your account to start using AI Plan',
        aiPlanTitle: 'AI PLAN',
        aiPlanDescription: 'AI Plan is a user-friendly tool, based on <strong>Artificial Intelligence</strong>, for a more streamlined and efficient internal quality assurance process.',
        copyright: 'by',
        
        // Error messages
        error: 'Error!!',
        somethingWentWrong: 'Something went wrong!!',
        yourEmailIsNotAllowedToEnterWithGoogle: 'Your email is not allowed to enter with Google',
        oops: 'OOOPSS!!',
        thereWasSomeProblemsDuringTheGoogleLogin: 'There was some problems during the Google Login',
        UserNotFound: "Multiple user or not found",
        UserAccountDisabled: "Unabled user",
        WrongOAuth: "Authentication method is wrong",
        WrongPassword: "Email and/or password is wrong"
    }
};
